export const KRE8_VIDEO_ORDER_FEE_RATE = 0.06;
export const STRIPE_CARD_FEE_RATE = 0.029;
export const STRIPE_CARD_FIXED_FEE_CENTS = 30;

const centsToDollars = (cents) => cents / 100;

export function calculateVideoOrderCharge(editorPrice) {
  const editorPriceCents = Math.round(Number(editorPrice) * 100);
  if (!Number.isInteger(editorPriceCents) || editorPriceCents < 1) {
    throw new Error("Enter a valid editor price.");
  }

  const platformFeeCents = Math.round(
    editorPriceCents * KRE8_VIDEO_ORDER_FEE_RATE
  );
  const totalCents = Math.ceil(
    (editorPriceCents + platformFeeCents + STRIPE_CARD_FIXED_FEE_CENTS) /
      (1 - STRIPE_CARD_FEE_RATE)
  );
  const processingFeeCents =
    totalCents - editorPriceCents - platformFeeCents;

  return {
    editorPrice: centsToDollars(editorPriceCents),
    platformFee: centsToDollars(platformFeeCents),
    processingFee: centsToDollars(processingFeeCents),
    fees: centsToDollars(platformFeeCents + processingFeeCents),
    total: centsToDollars(totalCents),
  };
}
